import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function LatestArticles() {
  const latest = articles.filter((a) => !a.featured).slice(0, 5);

  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最新内容
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            持续更新的精彩内容，第一时间获取平台最新资讯
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col sm:flex-row gap-5 bg-background-50 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:scale-[1.01]"
            >
              <div className="w-full sm:w-48 h-36 sm:h-32 rounded-lg overflow-hidden shrink-0">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 91叔叔`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs bg-accent-100 text-accent-700 px-2.5 py-0.5 rounded-full font-medium">
                    {article.category === 'guide' ? '使用指南' :
                     article.category === 'resource' ? '资源推荐' :
                     article.category === 'member' ? '会员专区' :
                     article.category === 'news' ? '最新动态' :
                     article.category === 'tips' ? '实用技巧' : '社区互动'}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}